function Menu(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={25}
      height={22}
      viewBox="0 0 25 22"
      {...props}
    >
      <path
        d="M.22 0h24v2h-24zm0 10h24v2h-24zm0 10h16v2h-16z"
        fill={props.color || "#FFF"}
        fillRule="evenodd"
      />
    </svg>
  );
}

export default Menu;
